
import classNames from 'classnames/bind';
import globalStyles from './../App.css';

export default classNames.bind(globalStyles);
